export default "__VITE_ASSET__BYYzEft7__"